import angular from 'angular';
import _ from 'underscore';
import $ from 'jquery';

export default class UserDetails {
  constructor($scope, $rootScope, GeoService, UserService, UserAddressService, UserBankService, UiService) {
    $scope.tabs = ['Company Profile',
      'Company Addresses',
      'Company Intro',
      'Financial Details',
      'Banking Details'
    ];

    $scope.set_selected_tab = function(index) {
      $scope.selected_tab = index;
    };

    $scope.get_selected_tab = function() {
      return $scope.selected_tab;
    };

    $scope.open_dialog = function(dialog_id) {
      window.openFancyboxDialog('div#' + dialog_id);
    };

    $scope.$watch('user.country_id', function() {
      if ($scope.user.country_id) {
        GeoService.get_cities($scope.user.country_id).then(function(data) {
          $scope.cities = data.cities;
          if (!_.findWhere(data.cities, {id: $scope.user.city_id}))
            $scope.user.city_id = null;
        });
      }
    });

    $scope.$watch('dialog_address.country_id', function() {
      if ($scope.dialog_address.country_id) {
        GeoService.get_cities($scope.dialog_address.country_id).then(function(data) {
          $scope.dialog_address_cities = data.cities;
          if (!_.findWhere(data.cities, {id: $scope.dialog_address.city_id}))
            $scope.dialog_address.city_id = null;
        });
      }
    });

    $scope.$watch('dialog_bank.country_id', function() {
      if ($scope.dialog_bank.country_id) {
        GeoService.get_cities($scope.dialog_bank.country_id).then(function(data) {
          $scope.dialog_bank_cities = data.cities;
          if (!_.findWhere(data.cities, {id: $scope.dialog_bank.city_id}))
            $scope.dialog_bank.city_id = null;
        });
      }
    });

    $scope.$watch('user.user_type', function() {
      $scope.business_types = angular.copy(window.business_types);
      $scope.user.user_business_types_attributes = [];
    });

    $scope.yes_no_options = [
      {
        id: 0,
        title: 'No'
      },
      {
        id: 1,
        title: 'Yes'
      }
    ];

    $scope.add_address = function() {
      $scope.dialog_address = angular.copy(window.address);
      $scope.open_dialog('user_address_dialog');
    };

    $scope.edit_address = function(address) {
      $scope.dialog_address = address;
      $scope.open_dialog('user_address_dialog');
    };

    $scope.delete_address = function(index) {
      if (confirm('Are you sure you want to delete this address?')) {
        UserAddressService.delete($scope.user_addresses[index].id).then(function(data) {
          if (data.success) {
            $scope.user_addresses.splice(index, 1);
            $rootScope.$broadcast('set_sidebar_data', [1, 0, [{
              type: 'percentage',
              value: data.company_details_percentage
            }]]);
          }
        });
      }
    };

    $scope.save_address = function() {
      $scope.updating_address = true;
      UserAddressService.save($scope.dialog_address).then(function(data) {
        if (data.success) {
          $scope.updating_address = false;
          $.fancybox.close();
          $scope.user_addresses = data.user_addresses;
          $rootScope.$broadcast('set_sidebar_data', [1, 0, [{
            type: 'percentage',
            value: data.company_details_percentage
          }]]);
        }
      });
    };

    $scope.add_bank = function() {
      $scope.dialog_bank = angular.copy(window.bank);
      $scope.open_dialog('user_bank_dialog');
    };

    $scope.edit_bank = function(bank) {
      $scope.dialog_bank = bank;
      $scope.open_dialog('user_bank_dialog');
    };

    $scope.delete_bank = function(index) {
      if (confirm('Are you sure you want to delete this bank?')) {
        UserBankService.delete($scope.user_banks[index].id).then(function(data) {
          if (data.success) {
            $scope.user_banks.splice(index, 1);
            $rootScope.$broadcast('set_sidebar_data', [1, 0, [{
              type: 'percentage',
              value: data.company_details_percentage
            }]]);
          }
        });
      }
    };

    $scope.save_bank = function() {
      $scope.updating_bank = true;
      UserBankService.save($scope.dialog_bank).then(function(data) {
        if (data.success) {
          $scope.updating_bank = false;
          $.fancybox.close();
          $scope.user_banks = data.user_banks;
          $rootScope.$broadcast('set_sidebar_data', [1, 0, [{
            type: 'percentage',
            value: data.company_details_percentage
          }]]);
        }
      });
    };

    $scope.set_user_data = function() {
      $scope.user_business_types = [];
      angular.forEach($scope.business_types, function(business_type) {
        if (business_type.checked)
          $scope.user_business_types.push(business_type.id);
      });

      $scope.user_groups = [];
      angular.forEach($scope.groups, function(group) {
        if (group.checked)
          $scope.user_groups.push(group.id);
      });
    };

    $scope.update_user = function() {
      $scope.updating_user = true;
      $scope.set_user_data();
      UserService.update($scope.user, $scope.user_groups, $scope.user_business_types).then(function(data) {
        if (data.success) {
          $scope.business_relation_title = data.business_relation_title;
          $scope.eprivacy_title = data.eprivacy_title;
          $scope.epr_marketing_permission_title = data.epr_marketing_permission_title;
          $scope.epr_marketing_campaigns_title = data.epr_marketing_campaigns_title;
          $scope.gdpr_compliance_title = data.gdpr_compliance_title;
          $scope.updating_user = false;
          $scope.set_financial_details_badge();
          $scope.set_company_introduction_badge();
          $scope.set_company_profile_badge();
          $rootScope.$broadcast('set_sidebar_data', [1, 0, [{
            type: 'percentage',
            value: data.company_details_percentage
          }]]);
        }
      });
    };

    $scope.set_financial_details_badge = function() {
      var percentage = 0;
      if ($scope.user.founded_on)
        percentage += 20;
      if ($scope.user.managing_director && $scope.user.managing_director.length > 0)
        percentage += 20;
      if ($scope.user.num_employees)
        percentage += 20;
      if ($scope.user.annual_turnover)
        percentage += 20;
      if ($scope.user.annual_imports)
        percentage += 20;
      $scope.financial_details = {
        css: UiService.get_count_css_class(percentage),
        percentage: percentage
      };
    };

    $scope.set_company_introduction_badge = function() {
      var percentage = 0;
      if ($scope.user.company_introduction)
        percentage += 34;
      if ($scope.user.company_notes)
        percentage += 33;
      if ($scope.user.epaper_introduction)
        percentage += 33;
      $scope.company_introduction = {
        css: UiService.get_count_css_class(percentage),
        percentage: percentage
      };
    };

    $scope.set_company_profile_badge = function() {
      $scope.set_user_data();
      var percentage = 0;
      if ($scope.user.company_title)
        percentage += 12.5;
      if ($scope.user.ssn)
        percentage += 12.5;
      if ($scope.user.country_id)
        percentage += 12.5;
      if ($scope.user.city_id)
        percentage += 12.5;
      if ($scope.user.phone)
        percentage += 12.5;
      if ($scope.user.fax)
        percentage += 12.5;
      if ($scope.user_groups.length > 0)
        percentage += 12.5;
      if ($scope.user_business_types.length > 0)
        percentage += 12.5;
      percentage = Math.floor(percentage);
      $scope.company_profile = {
        css: UiService.get_counter_css_class(percentage),
        percentage: percentage
      };
    };

    $scope.init = function() {
      $scope.selected_tab = 0;
      $scope.countries = window.countries;
      $scope.groups = angular.copy(window.groups);
      $scope.business_types = angular.copy(window.business_types);
      $scope.user = window.user;
      $scope.user_groups = [];
      $scope.user_business_types = [];
      $scope.user_addresses = window.user_addresses;
      $scope.user_banks = window.user_banks;
      $scope.dialog_address = angular.copy(window.address);
      $scope.dialog_bank = angular.copy(window.bank);
      $scope.business_relation_title = window.business_relation_title;
      $scope.eprivacy_title = window.eprivacy_title;
      $scope.epr_marketing_permission_title = window.epr_marketing_permission_title;
      $scope.epr_marketing_campaigns_title = window.epr_marketing_campaigns_title;
      $scope.gdpr_compliance_title = window.gdpr_compliance_title;
      $scope.offer_campaign_criteria_statuses = window.offer_campaign_criteria_statuses;
      $scope.set_financial_details_badge();
      $scope.set_company_introduction_badge();
      $scope.set_company_profile_badge();
    };

    $scope.init();
  }
}

UserDetails.$inject = ['$scope', '$rootScope', 'GeoService', 'UserService', 'UserAddressService', 'UserBankService', 'UiService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/user-details.ctrl.js